export default function cookieGet(key: string) {
  const keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
  return keyValue ? decodeURIComponent(keyValue[2]) : null;
}
